import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    neutral?: PaletteOptions["primary"];
  }
}

// @babel-ignore-comment-in-output Update the Button's color prop options
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
}

const table2Theme = createTheme({
  components: {
    MuiTable: {
      defaultProps: {
        size: "small",
        "aria-label": "a dense table",
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          fontSize: 12,
          color: "#231F20",
          // border: "2px solid #D9D9D9",
          maxHeight: 20,
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          fontSize: 12,
          color: "#595959",
          borderWidth: 2,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          margin: 0,
          padding: "8px 0px",
          borderBottom: "1px solid #D9D9D9",
          "&.Header": {
            padding: "8px 0px",
            paddingBottom: 0,
            borderBottom: "3px solid #D9D9D9",
          },
        },
      },
    },
    MuiTableCell: {
      defaultProps: {
        padding: "none",
        align: "left",
      },
      styleOverrides: {
        root: {
          paddingRight: 12,
          borderBottom: "inherit",
          fontWeight: "inherit",
          fontSize: "inherit",
          color: "inherit",
          padding: "inherit",
        },
      },
    },
  },
});

export { table2Theme };
